import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NachaResult, NachaMatch } from '../../../models/nacha.model';

@Component({
  selector: 'app-nacha-results-step',
  standalone: true,
  imports: [CommonModule, CurrencyPipe, MatIconModule, MatTableModule, MatButtonModule, MatTooltipModule],
  templateUrl: './results-step.component.html',
})
export class NachaResultsStepComponent {
  @Input() results: NachaResult[] = [];
  @Input() matches: NachaMatch[] = [];
  @Output() downloadResults = new EventEmitter<void>();
  @Output() viewReceipt = new EventEmitter<string>();
  @Output() downloadReceipt = new EventEmitter<string>();

  displayedColumns = ['status', 'individualId', 'customerName', 'amount', 'txType', 'transactionId', 'message', 'actions'];

  get successfulResults(): NachaResult[] {
    return this.results.filter((r) => r.status === 'success');
  }

  get failedResults(): NachaResult[] {
    return this.results.filter((r) => r.status === 'failed');
  }

  get skippedMatches(): NachaMatch[] {
    const processedIds = new Set(this.results.map((r) => r.match.row.rowIndex));
    return this.matches.filter((m) => !processedIds.has(m.row.rowIndex));
  }

  get totalAmount(): number {
    return this.successfulResults.reduce((sum, r) => sum + r.match.row.amount, 0);
  }

  get successRate(): number {
    const total = this.results.length;
    return total === 0 ? 0 : (this.successfulResults.length / total) * 100;
  }

  getStatusIcon(status: string): string {
    switch (status) {
      case 'success': return 'check_circle';
      case 'failed': return 'error';
      default: return 'help';
    }
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'success': return 'status-success';
      case 'failed': return 'status-error';
      default: return 'status-default';
    }
  }

  onDownloadResults(): void {
    this.downloadResults.emit();
  }

  onViewReceipt(transactionId: string): void {
    this.viewReceipt.emit(transactionId);
  }

  onDownloadReceipt(transactionId: string): void {
    this.downloadReceipt.emit(transactionId);
  }
}
